import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyDashboardsEditRoute: InvariantJiraRoute = {
	name: 'legacy-dashboards-edit',
	path: '(/secure/|/)EditPortalPage([!%]?[\\w]*).jspa',
};
